"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const core_1 = require("companion-app-components/utils/core");
// TODO: uncomment if dataset creating is needed in future
// import QButton from 'components/QButton';
// import QTip from 'components/QuickenControls/QTip';
// import { hasWebFirstEntitlements } from 'data/entitlements/entitlementsSelectors';
const utils_1 = require("utils/utils");
const Win_png_1 = __importDefault(require("assets/setup-page/Win.png"));
const Mac_png_1 = __importDefault(require("assets/setup-page/Mac.png"));
const Mac_Icon_png_1 = __importDefault(require("assets/setup-page/Mac Icon.png"));
const Win_Icon_png_1 = __importDefault(require("assets/setup-page/Win Icon.png"));
const styles_1 = require("./styles");
const log = (0, core_1.getLogger)('containers/SetupPageCompanion');
const stepsWin = [
    'Open Quicken Classic for Windows',
    'Click on Get Started on the Mobile & Web tab',
    'Click Done after selecting all your accounts',
    'Click on Sync Now, or do a One Step Update anytime to sync',
];
const stepsMac = [
    'Open Quicken Classic Mac',
    'Click on Preferences in the Quicken menu',
    'Click on Mobile, Web & Alerts in preferences window',
    'Turn Sync On',
];
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const SetupPageCompanion = ({ profile, authSession, defaultTabIsWindows,
// TODO: uncomment if dataset creating is needed in future
// onCreateDataset,
 }) => {
    var _a;
    const [isWindows, setIsWindows] = (0, react_1.useState)(defaultTabIsWindows !== undefined ? defaultTabIsWindows : !(0, utils_1.isMac)());
    const { classes } = useStyle();
    // TODO: uncomment if dataset creating is needed in future
    // const allowCreateDataset = useSelector(hasWebFirstEntitlements);
    const userEmail = ((_a = profile === null || profile === void 0 ? void 0 : profile.primaryEmail) === null || _a === void 0 ? void 0 : _a.address) || '';
    const macDownload = `https://download.quicken.com/mac/Quicken.dmg?email=${userEmail}`;
    const winDownload = `https://download.quicken.com/windows/Quicken.exe?email=${userEmail}`;
    const downloadLink = isWindows ? winDownload : macDownload;
    const steps = isWindows ? stepsWin : stepsMac;
    const stepsImg = isWindows ? Win_png_1.default : Mac_png_1.default;
    const suffix = isWindows ? 'for Windows' : 'Mac';
    const showBoth = true;
    (0, react_1.useEffect)(() => {
        if (defaultTabIsWindows !== undefined) {
            setIsWindows(defaultTabIsWindows);
        }
    }, [defaultTabIsWindows]);
    return (<div className={classes.setupWrapper}>
      <div className={classes.mAuto}>
        <Typography_1.default className={classes.title}>
          Hello.
        </Typography_1.default>
        <Typography_1.default className={classes.subTitle}>
          It looks like you have not synced your accounts yet
        </Typography_1.default>
        <Typography_1.default className={classes.bodyText}>
          {`To sync your accounts from Quicken Classic ${suffix}:`}
        </Typography_1.default>
        <div className={(0, classnames_1.default)(classes.tabWrapper, classes.mAuto)}>
          <div className={classes.choiceTabs}>
            {(showBoth || isWindows) && (<ButtonBase_1.default className={(0, classnames_1.default)(classes.tab, isWindows ? 'selected' : 'unselected')} onClick={() => setIsWindows(true)} disabled={!showBoth}>
                <div>
                  <img alt="Windows Icon" src={Win_Icon_png_1.default} className={(0, classnames_1.default)(classes.dInline, classes.platformImg)}/>
                  <Typography_1.default className={classes.dInline}>WINDOWS</Typography_1.default>
                </div>
              </ButtonBase_1.default>)}
            {(showBoth || !isWindows) && (<ButtonBase_1.default className={(0, classnames_1.default)(classes.tab, isWindows ? 'unselected' : 'selected')} onClick={() => setIsWindows(false)} disabled={!showBoth}>
                <div>
                  <img alt="Mac icon" src={Mac_Icon_png_1.default} className={(0, classnames_1.default)(classes.dInline, classes.platformImg)}/>
                  <Typography_1.default className={classes.dInline}>MAC</Typography_1.default>
                </div>
              </ButtonBase_1.default>)}
          </div>
          <div id="content" className={classes.stepWrapper}>
            <div id="steps" className={classes.stepSection}>
              {steps.map((step, index) => (<div key={`setup-step: ${step}`} className={classes.stepBox}>
                  <div className={classes.steps}>
                    <Typography_1.default className={classes.stepHeading}>{`Step ${index + 1}`}</Typography_1.default>
                    {index !== steps.length - 1 && <div className={classes.stepDivider}/>}
                  </div>
                  <Typography_1.default className={classes.bodyText}>{step}</Typography_1.default>
                </div>))}
            </div>
            <div className={classes.stepImg}>
              <img alt="graphical steps" src={stepsImg}/>
            </div>
            <div className={classes.footer}>
              <Divider_1.default className={classes.divider}/>
              <div className={classes.bodyText}>
                <Link_1.default className={classes.link} onClick={() => window.open('https://www.quicken.com/support/quicken-web-frequently-asked-questions', '_blank')}>
                  See this FAQ,
                </Link_1.default>
                &nbsp;on how to set your accounts up for Sync
                <div className={classes.vertBar}/>
                <Link_1.default className={classes.link} onClick={() => window.open(`https://www.quicken.com/my-account?bearer=${authSession.accessToken}`, '_blank')}>
                  Go to My Account
                </Link_1.default>
                <div className={classes.vertBar}/>
                <Link_1.default className={classes.link} onClick={() => {
            log.log(`Opening: ${downloadLink}`);
            window.open(downloadLink, '_blank');
        }}>
                  {`Download Quicken Classic for ${isWindows ? 'Windows' : 'Mac'}`}
                </Link_1.default>
              </div>
              {/* TODO: uncomment if dataset creating is needed in future */}
              {/* {
          allowCreateDataset &&
          <div className={classes.startClean}>
            <QTip
              title={`Creates a new cloud file that you can use on web and mobile, and then load into a Quicken ${suffix} when you want to use the desktop`}
            >
              <QButton onClick={() => onCreateDataset(isWindows ? 'quicken_windows' : 'quicken_mac')}>
                {`OR... Create New Quicken ${suffix} Dataset`}
              </QButton>
            </QTip>
          </div>
        } */}
            </div>
          </div>
        </div>
      </div>
    </div>);
};
exports.default = SetupPageCompanion;
